import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from "react-toastify";

const API = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use(
  config => {
    const token = Cookies.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Response Interceptor: Redirect on Unauthorized (401)
API.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      toast.error("Session Expired")
      Cookies.remove('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default API;
